<template>
  <DragDialog
    class="custom-dialog-box"
    title="更换缩略图"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel">
    <div :class="getThumbnailListClassName()">
      <div
        v-for="(item, index) in thumbnailList"
        :key="index"
        :class="`thumbnail-box ${
          selectThumbnailId === item.id ? 'active' : ''
        }`"
        @click="switchThumbnailId(item)">
        <div
          class="img-box"
          v-if="item.id !== 'custom'">
          <img :src="`${imageBaseUrl}/${item.imgSrc}?token=${getTokenId()}`" />
        </div>
        <div
          v-else
          class="thumbnail-uploader-box">
          <el-upload
            class="upload-primary"
            ref="upload"
            drag
            :action="uploadUrl"
            :headers="headers"
            :data="uploadParams"
            name="FileInfo"
            accept=".jpg,.jpeg,.png,.gif,.tif,.psd"
            :show-file-list="false"
            :on-change="handleChange"
            :on-success="handleAvatarSuccess"
            :on-error="handleAvatarError"
            :auto-upload="false">
            <div
              v-if="item.imgSrc"
              class="avatar-box">
              <img
                :src="getImgSrc(item)"
                class="avatar" />
              <div class="mask-box">
                <div class="btn-box">更换图片</div>
              </div>
            </div>
            <div
              v-else
              class="icon-box">
              <icon-svg
                size="20"
                icon-class="ic-ico_upload"
                class="icon" />
              <div>
                <div>支持jpg/png格式</div>
              </div>
            </div>
          </el-upload>
        </div>
        <div class="thumbnail-description">{{ item.name }}</div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'
import logServeCof from '@/plugins/logServeCof.js'
import {
  getBase64,
  compressImgBySize,
  getToken,
  getTokenId
} from '@/utils/generalMethods'

import {
  publicElemThumbnailListService,
  publicElemChangeThumbnailService,
  privateElemThumbnailListService,
  privateElemChangeThumbnailService
} from '@/service/interface'

const CompressSize = 2 * 1024 * 1024

export default {
  data() {
    return {
      imageBaseUrl: `${window.imageBaseUrl}`,
      thumbnailList: [],
      selectThumbnailId: '',

      uploadUrl: this.getUploadUrl(),
      headers: {
        Authorization: this.getToken()
      },
      uploadParams: {
        FileName: '',
        FileSize: '',
        DataSetId: ''
      },
      imageSrc: '',

      nameMapArray: [
        { id: 'default', name: '默认视图' },
        { id: 'front', name: '主视图' },
        { id: 'left', name: '左视图' },
        { id: 'top', name: '俯视图' },
        { id: 'right', name: '右视图' },
        { id: 'back', name: '后视图' },
        { id: 'bottom', name: '底视图' },
        { id: 'custom', name: '自定义' }
      ]
    }
  },
  props: {
    visible: Boolean,
    type: String,
    elemInfo: Object,
    updateDataList: Function,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initThumbnailList()
      } else {
        this.selectThumbnailId = ''
        this.thumbnailList = []
        this.nameMapArray = [
          { id: 'default', name: '默认视图' },
          { id: 'front', name: '主视图' },
          { id: 'left', name: '左视图' },
          { id: 'top', name: '俯视图' },
          { id: 'right', name: '右视图' },
          { id: 'back', name: '后视图' },
          { id: 'bottom', name: '底视图' },
          { id: 'custom', name: '自定义' }
        ]
      }
    }
  },

  methods: {
    initThumbnailList() {
      return new Promise(resolve => {
        let fileId = this.elemInfo.id
        if (this.type === 'PublicElem') {
          publicElemThumbnailListService(fileId).then(response => {
            if (response.isSuccess) {
              let data = response.data
              let thumbnailList = []
              if (data?.length) {
                this.nameMapArray.forEach(item => {
                  let find = data.find(el => el.name.includes(item.id))
                  if (find) {
                    item.imgSrc = find.imgSrc
                    item.isSelected = find.isSelected
                    thumbnailList.push(item)
                  }
                })
              }

              // prettier-ignore
              const isCustomExist = thumbnailList.find(item => item.id === 'custom')
              if (!isCustomExist) {
                thumbnailList.push({ id: 'custom', name: '自定义' })
              }

              let findSelectImg = thumbnailList.find(el => el.isSelected)
              if (findSelectImg) {
                this.selectThumbnailId = findSelectImg.id
              }

              if (thumbnailList.length === 1) {
                this.selectThumbnailId = thumbnailList[0].id
              }

              this.thumbnailList = thumbnailList
              resolve()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        } else {
          privateElemThumbnailListService(fileId).then(response => {
            if (response.isSuccess) {
              let data = response.data
              let thumbnailList = []
              if (data?.length) {
                this.nameMapArray.forEach(item => {
                  let find = data.find(el => el.name.includes(item.id))
                  if (find) {
                    item.imgSrc = find.imgSrc
                    item.isSelected = find.isSelected
                    thumbnailList.push(item)
                  }
                })
              }

              // prettier-ignore
              const isCustomExist = thumbnailList.find(item => item.id === 'custom')
              if (!isCustomExist) {
                thumbnailList.push({ id: 'custom', name: '自定义' })
              }

              let findSelectImg = thumbnailList.find(el => el.isSelected)
              if (findSelectImg) {
                this.selectThumbnailId = findSelectImg.id
              }

              if (thumbnailList.length === 1) {
                this.selectThumbnailId = thumbnailList[0].id
              }

              this.thumbnailList = thumbnailList
              resolve()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        }
      })
    },
    switchThumbnailId(thumbnailInfo) {
      if (this.selectThumbnailId === thumbnailInfo.id) {
        this.selectThumbnailId = ''
      } else {
        this.selectThumbnailId = thumbnailInfo.id
      }
    },
    submit() {
      let fileId = this.elemInfo.id

      let find = this.thumbnailList.find(el => el.id === this.selectThumbnailId)
      if (this.selectThumbnailId.includes('custom')) {
        if (!find.imgSrc) {
          this.$message.warning('请先上传自定义图片')
          return
        }
      }
      let params = {}
      if (find && find.imgSrc) {
        params = {
          fileId,
          imgSrc: find.imgSrc
        }
      }
      if (this.type === 'PublicElem') {
        publicElemChangeThumbnailService(params).then(response => {
          if (response.isSuccess) {
            this.updateDataList()
            this.selectThumbnailId = ''
            this.thumbnailList = []
            this.closeDialog()
          }
        })
      } else {
        privateElemChangeThumbnailService(params).then(response => {
          if (response.isSuccess) {
            this.updateDataList()
            this.selectThumbnailId = ''
            this.thumbnailList = []
            this.closeDialog()
          }
        })
      }
    },
    cancel() {
      this.selectThumbnailId = ''
      this.thumbnailList = []
      this.nameMapArray = [
        { id: 'default', name: '默认视图' },
        { id: 'front', name: '主视图' },
        { id: 'left', name: '左视图' },
        { id: 'top', name: '俯视图' },
        { id: 'right', name: '右视图' },
        { id: 'back', name: '后视图' },
        { id: 'bottom', name: '底视图' },
        { id: 'custom', name: '自定义' }
      ]
      this.closeDialog()
    },
    handleChange(file) {
      this.$set(this.uploadParams, 'FileName', file.name)
      let dataSetId = this.elemInfo.dataSetId
      this.$set(this.uploadParams, 'DataSetId', dataSetId)

      let upload = this.$refs.upload[0]
      if (file.size < CompressSize) {
        this.$set(this.uploadParams, 'FileSize', file.size)
        upload.submit()
      } else {
        this.getBase64(file.raw).then(response => {
          this.compressImgBySize(response, 2 * 1024).then(res => {
            let fileOfBlob = new File([res], file.name)
            this.$set(this.uploadParams, 'FileSize', fileOfBlob.size)
            this.$set(this.uploadParams, 'FileInfo', fileOfBlob)
            upload.submit()
          })
        })
      }
    },
    handleAvatarSuccess(response, file) {
      // 图片上传成功
      if (response.isSuccess) {
        this.initThumbnailList().then(() => {
          let find = this.thumbnailList.find(el => el.id === 'custom')
          if (find) {
            this.selectThumbnailId = find.id
          }
        })
      } else {
        this.$message.error(response.errMsg)
      }
    },
    handleAvatarError() {
      this.$message.error('图片上传失败')
    },
    getImgSrc(imgInfo) {
      let url = `${this.imageBaseUrl}/${imgInfo.imgSrc}?token=${getTokenId()}`
      let timestamp = new Date().getTime()
      let src = `${url}&timestamp=${timestamp}`
      return src
    },
    getUploadUrl() {
      const baseUrl = `${window.serverUrl}/${logServeCof.logServeCof()}/project`
      let uploadUrl = ''
      if (this.type === 'PublicElem') {
        uploadUrl = `${baseUrl}/componentLibrary/v3/public/clThumbnail/upload`
      } else {
        uploadUrl = `${baseUrl}/componentLibrary/v3/private/clThumbnail/upload`
      }

      return uploadUrl
    },
    getThumbnailListClassName() {
      let calssName = 'thumbnail-list-box'
      if (this.thumbnailList.length > 1) {
        calssName += ' is-multi'
      }
      return calssName
    },
    getBase64,
    compressImgBySize,
    getToken,
    getTokenId
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

.custom-dialog-box {
  :deep(.dialog-box) {
    width: unset !important;
    min-width: 320px;
  }
}

.thumbnail-list-box {
  display: grid;
  place-items: center;
  gap: 20px;

  &.is-multi {
    grid-template-columns: repeat(4, 1fr);
  }

  .thumbnail-box {
    position: relative;
    width: 180px;
    height: 180px;
    padding: 0px 20px;
    cursor: pointer;
    border-radius: 6px;
    border: 1px solid transparent;
    background-color: var(--element-page-dialog-item-bgColor);

    &:hover {
      border: 1px solid var(--base-primary-bgColor);
      .img-box {
        .common-checkbox-box {
          display: block;
        }
      }

      .thumbnail-uploader-box {
        .common-checkbox-box {
          display: block;
        }
      }
    }

    &.active {
      border: 1px solid var(--base-primary-bgColor);
      .img-box {
        .common-checkbox-box {
          display: block;
        }
      }

      .thumbnail-uploader-box {
        .common-checkbox-box {
          display: block;
        }
      }
    }

    .img-box {
      position: relative;
      width: 135px;
      height: 120px;
      margin: 15px auto 0px auto;

      img {
        width: 100%;
        height: 100%;
      }

      .common-checkbox-box {
        position: absolute;
        top: -2px;
        left: 5px;
        display: none;
      }
    }

    .thumbnail-uploader-box {
      margin: 15px auto 0px auto;

      .upload-primary {
        width: 135px;
        height: 120px;

        .icon-box {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }
      .common-checkbox-box {
        position: absolute;
        top: 5px;
        left: 5px;
        display: none;
      }

      :deep(.el-upload) {
        height: 100%;
      }

      /deep/ .el-upload-dragger {
        display: flex;
        height: 100%;
        border: none;
        background: none;
      }

      .avatar-box {
        position: relative;
        width: 100%;
        height: 100%;

        &:hover {
          .mask-box {
            display: flex;
          }
        }

        .avatar {
          width: 100%;
          height: 100%;
        }
        .icon {
          position: absolute;
          top: 6px;
          right: 6px;
          color: var(--default-color);
          background: var(--base-bg-dark-color5);
          padding: 5px;
          border-radius: 50%;
          font-size: 12px;
        }

        .mask-box {
          position: absolute;
          display: none;
          top: 0px;
          left: 0px;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.6);

          .btn-box {
            margin: auto;
            color: #ffffff;
            font-size: 14px;

            &:hover {
              color: var(--base-primary-bgColor);
              text-decoration: underline;
            }
          }
        }
      }

      .icon-box {
        margin: auto;
        line-height: 25px;
        color: var(--base-dark4-color);
        font-size: 12px;
        .icon {
          color: var(--base-dark5-color);
          font-size: 32px;
        }
      }

      .img-description {
        color: var(--base-dark6-color);
      }
    }

    .thumbnail-description {
      margin-top: 10px;
      color: var(--default-color);
      font-size: 16px;
      text-align: center;
    }

    &:nth-child(4) ~ div {
      margin-bottom: 0px;
    }

    &:nth-child(4n) {
      margin-right: 0px;
    }
  }
}
</style>
